import { useRouter } from 'next/router';
import React from 'react';

import { Flex } from '@/box';
import { useActiveBrandConfig } from '@/brand/common/hooks/useActiveBrandConfig';
import { useTranslation } from '@/i18n';
import { Button } from '@/ui/controls';

const BUTTON_STYLES = {
  width: '50%',
  minWidth: '50%',
} as const;

interface ActionButtonsProps {
  onHomeClick: () => void;
  onDefaultSearchClick: () => void;
}

const ActionButtons = ({
  onHomeClick,
  onDefaultSearchClick,
}: ActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    <Flex gap="16px">
      <Button variant="secondary" css={BUTTON_STYLES} onClick={onHomeClick}>
        {t('common:no')}
      </Button>
      <Button
        variant="primary"
        css={BUTTON_STYLES}
        onClick={onDefaultSearchClick}
      >
        {t('common:yes')}
      </Button>
    </Flex>
  );
};

export const NoBlockCodeRoomsAvailableButtons = () => {
  const router = useRouter();
  const { homeUrl } = useActiveBrandConfig();

  const handleDefaultSearch = () => {
    // Remove the rateCode and rateCodeType from the query params to make a default search
    const { rateCode, rateCodeType, ...remainingParams } = router.query;
    router.push({
      pathname: router.pathname,
      query: remainingParams,
    });
  };

  const handleHomeNavigation = () => {
    router.push(homeUrl);
  };

  return (
    <ActionButtons
      onHomeClick={handleHomeNavigation}
      onDefaultSearchClick={handleDefaultSearch}
    />
  );
};
